<template>
<div>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link class="navbar-brand" to="/">
        <img class="n-logo" src="img/icon.png" alt="Mollusca" />
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Twitter"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-twitter"></i>
          <p class="d-lg-none d-xl-none">Twitter</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Like us on Facebook"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Instagram"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item" :class="{ active: isActive('es') }">
        <a
          class="nav-link active"
          rel="tooltip"
          title="Español"
          data-placement="bottom"
          @click="changeLanguage('es')"
        >
          Español
        </a>
      </li>
      <li class="nav-item" :class="{ active: isActive('en-US') }">
        <a
          class="nav-link"
          rel="tooltip"
          title="Español"
          data-placement="bottom"
          @click="changeLanguage('en-US')"
        >
          English
        </a>
      </li>
    </template>
  </navbar>
  <div id="modals_content">
      
    </div>
  </div>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button, Modal } from '@/components';
import { Popover } from 'element-ui';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    Modal,
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  data() {
    return {
      modals: {
        login: false,
        signup: false,
        restore: false
      },
      activeL: this.$store.getters.getLocale
    };
  },
  methods: {
    changeLanguage (locale) {
      this.$i18n.locale = locale
      this.activeL = locale
    },
    isActive: function (l) {
      return this.activeL === l
    }
  }
};
</script>

<style scoped></style>